<template lang="html">
  <header>
    <section>
      <router-link to="/">Nicholas Cornish</router-link>
      <button class="screen-only langToggle" @click="toggleLang">
        <span :class="{ active: is_EN_active }">{{langs[0]}}</span> /
        <span :class="{ active: !is_EN_active }">{{langs[1]}}</span>
      </button>
    </section>
    <nav class="screen-only">
      <router-link v-for="(link, index) in navItems"
          :to="link.path" exact
          :key="index">{{link.label}}
      </router-link>
    </nav>
  </header>
</template>

<script>
import langMixin from '../mixins/langMixin';

export default {
  name: 'Header',
  computed: {
    navItems() {
      return this.$i18n.t('nav.entries');
    },
  },
  mixins: [langMixin],
};
</script>

<style lang="scss" scoped>
header {
  nav {
    @include xCols(12);
    a {
      color: $mid !important;
      text-decoration: none;
      @include trans();
      &.router-link-active {
        color: $dark !important;
        // &:before {
        //   display: inline-block;
        //   content: "";
        //   width: 2px;
        //   height: 2px;
        //   border-radius: 20px;
        //   background-color: aqua;
        // }
      }
    }
  }
}
section {
  @include xCols(2);
  a {
    text-decoration: none;
  }
}
section, nav {
  @media screen {
    margin-bottom: ms(2);
  }
}
.langToggle {
  border: none;
  background: none;
  padding: 0;
  text-transform: uppercase;
  text-align: right;
  &:focus {
    outline-width: 0px;
  }
  span {
    color: $mid;
    pointer-events: none; // allows click-through handler for button element
    &.active {
      color: $primary;
      @include trans();
    }
  }
}
</style>
